import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../store";

import { FormInput } from "./welcome.slice";

export const SelectRedirect = (store: RootState): string | null =>
  store.welcome.redirect;

export const selectWelcomeData = (store: RootState): FormInput =>
  store.welcome.data;

export const selectIsFormValidated = (store: RootState): boolean =>
  store.welcome.validated;

export const WelcomeFormVisited = (store: RootState): boolean => {
  return store.welcome.validated;
};

/*
export const selectVehicleDriveable = createSelector(
  selectWelcomeData,
  (state) => state.vehicleDriveable
);
*/
